export default {
    ai: 'Assistant IA',
    export: 'Exportation',
    blue: 'Bleu',
    yellow: 'Jaune',
    pink: 'Rose',
    orange: 'Orange',
    all: 'Tous',
    generateApaCopy: 'Générer une citation APA',
    apaCopied: 'Citation copiée dans le presse-papiers !',
    imReading: 'Je lis',
    in: 'dans',
    by: 'Par',
    article: 'Article',
    prevArticle: 'Article précédent',
    nextArticle: 'Article suivant',
    imHere: 'Oui, je suis là',
    sessionExpiredAlert: 'Votre session de lecture est sur le point de se terminer.',
    sessionExpiredAreYouThere: 'Êtes-vous là ?',
    sessionExpired: "Votre session de lecture a expiré en raison d'inactivité.",
    returnToLibrary: 'Revenir à la bibliothèque',
    sessionValidExpired: 'Session expirée',
    sessionValidExpiredPleaseLoginAgain: 'Veuillez vous connecter à nouveau',
    tableOfContents: 'Table des matières',
    tableOfContentsNotAvailable: 'Aucun sommaire disponible.',
    pages: 'pages',
    page: 'page',
    thumbnails: 'Miniatures',
    settings: 'Paramètres',
    bookmarks: 'Signets',
    highlights: 'Surlignages',
    highlight: 'Surlignage',
    notes: 'Notes',
    note: 'Note',
    notebook: 'Carnet',
    search: 'Chercher',
    theme: 'Thème',
    readingModes: 'Modes de lecture',
    zoomTitle: 'Taille du texte',
    zoomTitlePdf: 'Zoom',
    zoomTimes: 'Fois',
    typography: 'Typographie',
    fontDefault: 'Par défaut',
    lineSpacing: 'Interligne',
    lineSpacingCompact: 'Compact',
    lineSpacingNormal: 'Normal',
    lineSpacingWide: 'Large',
    margins: 'Marges',
    marginsMinimum: 'Minimum',
    marginsNormal: 'Normal',
    marginsMaximum: 'Maximum',
    pageLayout: 'Mise en page',
    continuous: 'Continu',
    onePage: 'Horizontal',
    onePageScroll: 'Vertical',
    twoPages: 'Double',
    twoPagesScroll: 'Défilement de deux pages',
    citation: {
        buttons: {
            Iso690: 'Générer une citation ISO690',
            APA: 'Générer une citation APA',
            Vancouver: 'Générer une citation Vancouver',
            IEEE: 'Générer une citation IEEE',
            MLA: 'Générer une citation MLA',
            ABNT: 'Générer une citation ABNT',
        },
        menu: {
            title: 'Générer une citation',
            Iso690: 'ISO 690',
            APA: 'APA',
            Vancouver: 'Vancouver',
            IEEE: 'IEEE',
            MLA: 'MLA',
            ABNT: 'ABNT',
        },
        messages: {
            copied: 'Citation copiée dans le presse-papiers !',
            availableIn: 'Disponible sur',
            online: 'Internet',
            generated: 'cité',
            websiteName: 'publica.la',
            and: 'et',
        },
    },
    'ai-integrations': {
        buttons: {
            explain: 'Expliquer le concept',
            expand: 'Développer les informations',
            summarize: "Résumer l'idée",
        },
        menu: {
            title: 'Assistant IA (Beta)',
        },
        messages: {
            copied: 'Réponse copiée dans le presse-papiers !',
            addedToResponse: '«Réponse copiée depuis publica.la Reader»',
        },
        thanksFeedback: 'Merci pour votre retour !',
        errorFeedback: "Échec de l'envoi des commentaires. Pouvez-vous réessayer ?",
    },
    onlyCopy: 'Copier le texte brut',
    translate: 'Traduire',
    copy: 'Copier',
    changeColor: 'Changer la couleur',
    socialShare: 'Partager',
    zoom: {
        auto: 'Auto',
        'page-fit': 'Ajuster à la page',
        'page-width': 'Largeur de page',
    },
    filter: 'Filtrer',
    noFilterHighlights: 'Sélectionnez un filtre pour voir vos surlignages',
    noFilterHighlightsColor: "Il n'y a rien de surligné dans cette couleur",
    noHighlights: "Vous n'avez pas encore fait de surlignages",
    noFilterNotes: 'Sélectionnez une couleur pour voir vos notes',
    noFilterNotesColor: "Il n'y a pas de notes de cette couleur",
    noNotes: "Vous n'avez pas encore écrit de notes",
    noFilterHighlightsAndNotes: 'Sélectionnez une couleur pour voir vos surlignages et notes',
    noFilterHighlightsAndNotesColor: "Il n'y a pas de notes ou de surlignages de cette couleur",
    noHighlightsAndNotes: "Vous n'avez pas encore créé de surlignages ou de notes",
    plainCopied: 'Texte copié dans le presse-papiers !',
    onboarding: {
        next: 'Suivant',
        finish: 'Terminer',
        skip: 'Passer le tutoriel',
        previous: 'Précédent',
        reader: {
            welcome: {
                title: 'Bienvenue dans votre espace de lecture',
                paragraph:
                    'Découvrez comment tirer le meilleur parti de vos livres avec les outils disponibles dans le lecteur.',
                extraParagraph: 'Profitez de votre nouvel espace de lecture!',
            },
            highlights: {
                title: 'Améliorez votre expérience de lecture',
                paragraph:
                    'Sélectionnez du texte, surlignez, créez des notes, générez des citations, traduisez et écoutez le contenu. Passez votre expérience de lecture au niveau supérieur dans tous les formats.',
            },
            resumes: {
                title: 'Gérez votre contenu',
                paragraph:
                    'Augmentez votre productivité. Gérez vos notes, surlignages, citations et résumés selon vos préférences. Partagez vos idées rapidement et facilement.',
            },
            appPromote: {
                title: 'Lisez ou écoutez partout',
                paragraph:
                    "Accédez à votre contenu quand et comme vous le souhaitez, sans connexion Internet, sur l'appareil de votre choix.",
                extraParagraph: 'Téléchargez notre application!',
            },
        },
        audiobook: {
            welcome: {
                title: 'Bienvenue',
                subTitle: 'Comment utiliser le lecteur ?',
                paragraph: 'Apprenez à utiliser les fonctions et à tirer le meilleur parti de votre écoute.',
            },
            reproduction: {
                title: 'Contrôle de lecture',
                paragraph: 'Avancez, reculez ou mettez en pause la lecture du livre audio.',
            },
            narratorSpeed: {
                title: 'Augmenter et réduire la vitesse de narration',
                paragraph: "Vous pouvez choisir la vitesse d'écoute du livre audio selon vos préférences.",
            },
            chapters: {
                title: 'Avancer et reculer dans les chapitres',
                paragraph: 'Déplacez-vous entre les chapitres de manière agile et rapide.',
            },
        },
    },
    author: 'Auteur',
    publisher: 'Éditeur',
    narrator: 'Narrateur',
    narratedBy: 'Narré par',
    aboutThisPublication: 'À propos de cette publication',
    listening: {
        label: 'Écoute',
        voice: 'Voix',
    },
    searchResultEmpty: 'Aucun résultat trouvé',
    searchLengthError: 'La recherche doit comporter entre 4 et 128 caractères',
    keepTyping: 'Continuez à écrire…',
    loading: 'Chargement...',
    searchLoading: 'Recherche en cours...',
    searchTitle: 'Recherche',
    lastSearch: 'Suggestions',
    searchExplanation: 'Trouvez des mots rapidement dans toute la publication',
    networkIsOffline: 'Pas de connexion internet disponible. Certaines fonctionnalités ne sont pas disponibles.',
    about: 'À propos',
    chapters: 'Chapitres',
    duration: 'Durée',
    narratorSpeed: 'Vitesse de narration',
    slowNarration: 'Narration lente',
    normalNarration: 'Narration normale',
    fastNarration: 'Narration rapide',
    shareIssue: 'Partager la publication',
    shareArticle: "Partager l'article",
    copyUrl: "Copier l'URL",
    shareCurrentPage: 'Partager la page actuelle',
    shareCurrentPosition: 'Partager la position actuelle',
    copyUrlToClipboard: 'URL copiée dans le presse-papiers',
    tooltips: {
        zoomOut: 'Zoom arrière',
        zoomIn: 'Zoom avant',
        config: 'Configuration',
        tableOfContents: 'Table des matières',
        search: 'Rechercher',
        highlights: 'Surlignages',
        notebook: 'Carnet',
        listen: 'Écouter',
        bookmarks: 'Signets',
        openThumbnails: 'Miniatures',
        closeThumbnails: 'Fermer les miniatures',
        download: 'Accès hors ligne',
        share: 'Partager',
        prev: 'Précédent',
        next: 'Suivant',
        close: 'Fermer',
        back: 'Retour',
        themeTitle: 'Apparence',
        themeLight: 'Clair',
        themeDark: 'Sombre',
        themeCream: 'Crème',
        themeSepia: 'Sépia',
        themeCyan: 'Cyan',
        themeHighContrast: 'Contraste élevé',
        themeHighContrastDark: 'Contraste élevé sombre',
        clear: 'Effacer',
        citation: 'Citation',
        dictionary: 'Dictionnaire',
        aiIntegrations: 'Assistant IA (Beta)',
        aiAction:
            "Cet outil utilise l'IA, il peut donc y avoir des informations inexactes. Davantage d'améliorations bientôt disponibles ! Qu'en pensez-vous ? Utilisez les icônes ci-dessous pour partager vos pensées.",
        translate: 'Traduire',
        about: 'À propos',
        rewind: 'Reculer',
        forward: 'Avancer',
        createNote: 'Créer une note',
        createHighlight: 'Surligner',
        deleteHighlight: 'Supprimer le surlignage',
        help: 'Aide',
        lists: 'Listes',
        copy: 'Copier',
        goodResponse: 'Bonne réponse',
        badResponse: 'Mauvaise réponse',
        ai: 'Assistant IA',
        moreActions: "Plus d'actions",
        moreOptions: "Plus d'options",
        play: 'Lire',
        pause: 'Pause',
        seekPosition: 'Position de la piste',
        zoomReset: 'Réinitialiser le zoom',
        smartZoom: 'Smart Zoom',
        themeSystem: 'Thème système',
        searchInBook: 'Rechercher dans le livre',
        pageSlider: 'Navigation par page',
    },
    save: 'Enregistrer',
    delete: 'Supprimer',
    cancel: 'Annuler',
    confirmDelete: {
        title: "Supprimer l'annotation",
        message: 'Êtes-vous sûr de vouloir supprimer cette annotation ? Cette action est irréversible.',
    },
    confirmResetSettings: {
        title: 'Réinitialiser les paramètres',
        message: 'Tous les paramètres visuels seront restaurés à leurs valeurs par défaut.',
    },
    resetSettings: 'Réinitialiser les paramètres',
    writeNote: 'Écrire une note',
    speakNow: 'Parlez maintenant',
    listeningSpeech: 'Écoute en cours',
    share: {
        copyShare: 'Copier et partager',
        qrCodeTitle: 'Code QR',
        scanQr: 'Scannez le code QR avec votre application WeChat',
        copyLink: "Copier l'URL de la publication",
        copy: 'Copier',
        copied: 'copié !',
        openWechat: "Ouvrir l'application WeChat",
        openingWechat: "Ouverture de l'application WeChat...",
        sendCopiedUrl: "Envoyer l'URL copiée à un contact",
    },
    playing: 'En cours de lecture',
    buyNow: 'Acheter maintenant',
    buyNowText: 'Obtenir la version complète.',
    preview: 'Aperçu',
    changeLayoutNotAllowed: 'Le contenu ne permet pas de changer la mise en page',
    nativeTtsLang: {
        'en-US': 'English (United States)',
        'en-GB': 'English (United Kingdom)',
        'en-scotland': 'English (Scotland)',
        'en-AU': 'English (Australia)',
        'en-IE': 'English (Ireland)',
        'en-IN': 'English (India)',
        'en-ZA': 'English (South Africa)',
        en: 'English',
        'es-AR': 'Spanish (Argentina)',
        'es-ES': 'Spanish (Spain)',
        'es-MX': 'Spanish (Mexico)',
        'es-US': 'Spanish (United States)',
        es: 'Spanish',
        'it-IT': 'Italian (Italy)',
        it: 'Italian',
        'pt-PT': 'Portuguese (Portugal)',
        'pt-BR': 'Portuguese (Brazil)',
        pt: 'Portuguese',
        'fr-CA': 'French (Canada)',
        'fr-FR': 'French (France)',
        fr: 'French',
        pl: 'Polish',
        'pl-PL': 'Polish (Poland)',
    },
    promoteApp: {
        downloadAppStore: "Télécharger sur l'App Store",
        downloadPlayStore: 'Obtenir sur Google Play',
        title_read: 'Emportez vos lectures partout avec',
        title_audio: 'Emportez vos livres audio partout avec',
        text: "Accédez à vos contenus quand et comme vous le souhaitez, sans connexion Internet, sur l'appareil de votre choix. Téléchargez notre application !",
        title_first_part: 'Avec',
        title_second_part: 'emmenez vos lectures partout où vous allez',
    },
    dictionary: 'Dictionnaire',
    selectionTooLongLine1: 'La sélection contient trop de mots.',
    selectionTooLongLine2: "Essayez de sélectionner jusqu'à 5 mots.",
    dictionaryValidation: {
        message: "Vous avez sélectionné {count} mots.\nVeuillez essayer de sélectionner jusqu'à {max} mots.",
    },
    translateValidation: {
        message:
            "Vous avez sélectionné {count} caractères.\nVeuillez essayer de sélectionner jusqu'à {max} caractères.",
    },
    ttsValidation: {
        message:
            "Vous avez sélectionné {count} caractères.\nVeuillez essayer de sélectionner jusqu'à {max} caractères.",
    },
    aiValidation: {
        message: 'Vous avez sélectionné {count} caractères.\nVeuillez sélectionner entre {min} et {max} caractères.',
    },
    alreadyPurchased: 'Déjà acheté ?',
    logIn: 'Se connecter',
    addToAList: 'Ajouter à une liste',
    nextSection: 'Section suivante',
    prevSection: 'Section précédente',
    lists: 'Listes',
    new: 'Nouveau',
    skipLinks: {
        navLabel: "Liens d'accès rapide",
        showControls: 'Afficher les contrôles',
    },
    accessibility: {
        textSelected: '{count} caractères sélectionnés. Outils de sélection disponibles.',
        pageChanged: 'Page {current} sur {total}',
    },
};
